export default __webpack_public_path__ + "static/media/ikyo.532f4b24.jpeg";